export var PhaseEntityType = /*#__PURE__*/ function(PhaseEntityType) {
    PhaseEntityType["Task"] = "TASK";
    PhaseEntityType["Sprint"] = "SPRINT";
    return PhaseEntityType;
}({});
export function isTask(entity) {
    return typeof entity.taskId === 'number';
}
export function isSprint(entity) {
    return typeof entity.sprintId === 'number';
}
export function extractId(entityId) {
    const lastUnderscoreIndex = entityId.lastIndexOf('_');
    const idString = entityId.substring(lastUnderscoreIndex + 1);
    return parseInt(idString, 10);
}
export function extractParts(entityId) {
    const parts = entityId.split('_');
    const entityType = parts.slice(0, -1).join('_');
    const id = parseInt(parts[parts.length - 1], 10);
    return {
        entityType,
        id
    };
}
export function converToEntityId(id, entityType) {
    return `${entityType}_${id}`;
}
export function convertKeyToEntityId(key) {
    const lastDashIndex = key.lastIndexOf('-');
    const entityId = `${key.substring(0, lastDashIndex)}_${key.substring(lastDashIndex + 1)}`;
    return entityId;
}
